import { createContext } from 'react'
import { Dataroom } from 'utils/__generated__/graphql'

export type DataroomContextType = {
  dataroom: Dataroom
}

const DataroomContext = createContext({} as DataroomContextType)

export default DataroomContext
